import { render, staticRenderFns } from "./NewChartChromatogram.vue?vue&type=template&id=37f88564&scoped=true&"
import script from "./NewChartChromatogram.vue?vue&type=script&lang=js&"
export * from "./NewChartChromatogram.vue?vue&type=script&lang=js&"
import style0 from "./NewChartChromatogram.vue?vue&type=style&index=0&id=37f88564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f88564",
  null
  
)

export default component.exports